'use strict';

var _Media = require('./Media');

var _Media2 = _interopRequireDefault(_Media);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO: Remove in the next major release.
_Media2.default.Media = _Media2.default; /* eslint-env node */


module.exports = _Media2.default;


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/react-media/index.js
// module id = 4264
// module chunks = 168707334958949